/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaEsercenteEligibilitaDTO } from '../model/models';
import { PraticaEsercentePerContoForm } from '../model/models';
import { PraticaEsercenteSubmitResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface EligibilitaPraticaEsercentePerContoRequestParams {
    idTipoPratica: string;
    profiloEsercenteId: string;
}

export interface SubmitPraticaEsercentePerContoRequestParams {
    idTipoPratica: string;
    allParts: { [key: string]: Blob; };
    pratica: PraticaEsercentePerContoForm;
}


export interface GestioneDomandeEsercentePerContoDellesercenteServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Eleggibilita\&#39; dell\&#39;esercente scelto a presentare domanda su questo bando.
     * Stesso esito del self-service (can_submit, reason, domanda_esistente_*), calcolato sul profilo indicato in profilo_esercente_id (non sul chiamante). checkTipoPratica GESTIONE. 404 se il profilo e\&#39; fuori dal perimetro del chiamante o il bando non e\&#39; raggiungibile dal canale operatore (flag di policy spento, modulo esercenti off, tipologia non ammessa). Un esercente bloccato dall\&#39;amministrazione non puo\&#39; ricevere domande: can_submit&#x3D;false con reason esercente_bloccato.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/per-esercente/eligibilita
* @param requestParameters
     */
    eligibilitaPraticaEsercentePerConto(requestParameters: EligibilitaPraticaEsercentePerContoRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteEligibilitaDTO>;

    /**
     * Presenta una domanda esercente per conto dell\&#39;esercente.
     * Multipart: part \&#39;pratica\&#39; (JSON {profilo_esercente_id, form_data, negozi_ids, da_pratica_esercente_id?, allegati_da_copiare?[{chiave, id_allegato}]}) + N part \&#39;allegato_&lt;chiave&gt;\&#39; (un upload esplicito vince sulla copia della stessa chiave). La domanda nasce SOTTOMESSA con l\&#39;operatore come inseritore, evento di creazione con attore OPERATORE e avviso email all\&#39;esercente dopo il commit. checkTipoPratica GESTIONE. Response 201: {id, codice_pratica, stato_richiesta}. 404 profilo fuori perimetro / bando non raggiungibile dal canale operatore / domanda sorgente o allegato da copiare non dello stesso profilo o di un bando non consultabile dal chiamante; 409 stato del bando non partecipabile o domanda attiva gia\&#39; presente; 422 validazione form, nessun negozio, allegato non copiabile (documento di sistema/convenzione) o su un campo diverso, MIME o dimensione di un allegato copiato non ammessi dal campo del bando, esercente bloccato dall\&#39;amministrazione (esercente_bloccato).
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/per-esercente
* @param requestParameters
     */
    submitPraticaEsercentePerConto(requestParameters: SubmitPraticaEsercentePerContoRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteSubmitResponseDTO>;

}
